import { render, staticRenderFns } from "./roomGroupDialog.vue?vue&type=template&id=3621ea00&scoped=true&"
import script from "./roomGroupDialog.vue?vue&type=script&lang=js&"
export * from "./roomGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./roomGroupDialog.vue?vue&type=style&index=0&id=3621ea00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3621ea00",
  null
  
)

export default component.exports